import { render } from "./AiImportFileUploadComponent.vue?vue&type=template&id=c0ee74e4"
import script from "./AiImportFileUploadComponent.vue?vue&type=script&lang=js"
export * from "./AiImportFileUploadComponent.vue?vue&type=script&lang=js"

import "./AiImportFileUploadComponent.vue?vue&type=style&index=0&id=c0ee74e4&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/admin/products/ai-import/AiImportFileUploadComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c0ee74e4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c0ee74e4', __exports__)) {
    api.reload('c0ee74e4', __exports__)
  }
  
  module.hot.accept("./AiImportFileUploadComponent.vue?vue&type=template&id=c0ee74e4", () => {
    api.rerender('c0ee74e4', render)
  })

}


export default __exports__